import { render, staticRenderFns } from "./AddTaskAction.vue?vue&type=template&id=6fb89a5a"
import script from "./AddTaskAction.vue?vue&type=script&lang=js"
export * from "./AddTaskAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports